// LIB
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

// STYLES
import { colors, fontFamily, fontSize } from '../../Design_System/DesignSystem';

// COMPONENT
import { Text } from '../atoms/Text';
import { Icon } from '../atoms/Icon';
import { useLanguage } from '../../i18n/LanguageContext';

const Project = () => {
  const { t } = useLanguage();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 843);
  const [selectedItem, setSelectedItem] = useState(0);
  const [oneHover, setOneHover] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 843);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Wrapper>
      <Container>
        <Section>
          <Title>
            <CustomIcon
              size={fontSize.mini}
              icon="emptyDot"
              color={colors.tan}
            />
            <Text
              color={colors.tan}
              fontSize={fontSize.small}
              fontFamily={fontFamily.tinos}
              bold={true}
              justify={false}
            >
              {t.project.business}
            </Text>
          </Title>
          <ProjectContainer
            onMouseEnter={() => {
              setOneHover(true);
              setSelectedItem(1);
            }}
            onMouseLeave={() => {
              setOneHover(false);
              setSelectedItem(0);
            }}
            oneHover={oneHover}
            selectedItem={selectedItem === 1}
            onClick={() =>
              window.open(
                'https://apps.apple.com/fr/app/ouihelp-pro/id1367442728',
                '_blank'
              )
            }
          >
            <Date
              color={colors.tan}
              fontSize={fontSize.small}
              fontFamily={fontFamily.tinos}
              bold={true}
              justify={false}
            >
              2019 / 2022
            </Date>
            <Text
              color={colors.tan}
              fontSize={isSmallScreen ? fontSize.small : fontSize.title}
              fontFamily={fontFamily.tinos}
              bold={false}
              justify={false}
            >
              / Ouihelp Mobil App
            </Text>
          </ProjectContainer>
          <ProjectContainer
            onMouseEnter={() => {
              setOneHover(true);
              setSelectedItem(2);
            }}
            onMouseLeave={() => {
              setOneHover(false);
              setSelectedItem(0);
            }}
            oneHover={oneHover}
            selectedItem={selectedItem === 2}
          >
            <Date
              color={colors.tan}
              fontSize={fontSize.small}
              fontFamily={fontFamily.tinos}
              bold={true}
              justify={false}
            >
              2019 / 2022
            </Date>
            <Text
              color={colors.tan}
              fontSize={isSmallScreen ? fontSize.small : fontSize.title}
              fontFamily={fontFamily.tinos}
              bold={false}
              justify={false}
            >
              / Ouihelp Intranet / API
            </Text>
          </ProjectContainer>
          <ProjectContainer
            onMouseEnter={() => {
              setOneHover(true);
              setSelectedItem(3);
            }}
            onMouseLeave={() => {
              setOneHover(false);
              setSelectedItem(0);
            }}
            oneHover={oneHover}
            selectedItem={selectedItem === 3}
            onClick={() =>
              window.open(
                'https://affectionate-bartik-0c2c4f.netlify.app/',
                '_blank'
              )
            }
          >
            <Date
              color={colors.tan}
              fontSize={fontSize.small}
              fontFamily={fontFamily.tinos}
              bold={true}
              justify={false}
            >
              2018
            </Date>
            <Text
              color={colors.tan}
              fontSize={isSmallScreen ? fontSize.small : fontSize.title}
              fontFamily={fontFamily.tinos}
              bold={false}
              justify={false}
            >
              / Portfolio 2018
            </Text>
          </ProjectContainer>
          <ProjectContainer
            onMouseEnter={() => {
              setOneHover(true);
              setSelectedItem(4);
            }}
            onMouseLeave={() => {
              setOneHover(false);
              setSelectedItem(0);
            }}
            oneHover={oneHover}
            selectedItem={selectedItem === 4}
            onClick={() => window.open('https://www.hairfax.fr/', '_blank')}
          >
            <Date
              color={colors.tan}
              fontSize={fontSize.small}
              fontFamily={fontFamily.tinos}
              bold={true}
              justify={false}
            >
              2017
            </Date>
            <Text
              color={colors.tan}
              fontSize={isSmallScreen ? fontSize.small : fontSize.title}
              fontFamily={fontFamily.tinos}
              bold={false}
              justify={false}
            >
              / Hairfax
            </Text>
          </ProjectContainer>
          <ProjectContainer
            onMouseEnter={() => {
              setOneHover(true);
              setSelectedItem(5);
            }}
            onMouseLeave={() => {
              setOneHover(false);
              setSelectedItem(0);
            }}
            oneHover={oneHover}
            selectedItem={selectedItem === 5}
            onClick={() =>
              window.open('https://www.kap-tourisme.fr/', '_blank')
            }
          >
            <Date
              color={colors.tan}
              fontSize={fontSize.small}
              fontFamily={fontFamily.tinos}
              bold={true}
              justify={false}
            >
              2016
            </Date>
            <Text
              color={colors.tan}
              fontSize={isSmallScreen ? fontSize.small : fontSize.title}
              fontFamily={fontFamily.tinos}
              bold={false}
              justify={false}
            >
              / Kap-Tourisme
            </Text>
          </ProjectContainer>
        </Section>
        <Section>
          <Title>
            <CustomIcon
              size={fontSize.mini}
              icon="emptyDot"
              color={colors.tan}
            />
            <Text
              color={colors.tan}
              fontSize={fontSize.small}
              fontFamily={fontFamily.tinos}
              bold={true}
              justify={false}
            >
              {t.project.school}
            </Text>
          </Title>
          <ProjectContainer
            onMouseEnter={() => {
              setOneHover(true);
              setSelectedItem(6);
            }}
            onMouseLeave={() => {
              setOneHover(false);
              setSelectedItem(0);
            }}
            oneHover={oneHover}
            selectedItem={selectedItem === 6}
            onClick={() =>
              window.open('https://admiring-wing-b7d9a1.netlify.app/', '_blank')
            }
          >
            <Date
              color={colors.tan}
              fontSize={fontSize.small}
              fontFamily={fontFamily.tinos}
              bold={true}
              justify={false}
            >
              2020
            </Date>
            <Text
              color={colors.tan}
              fontSize={isSmallScreen ? fontSize.small : fontSize.title}
              fontFamily={fontFamily.tinos}
              bold={false}
              justify={false}
            >
              / Center Mars
            </Text>
          </ProjectContainer>
          <ProjectContainer
            onMouseEnter={() => {
              setOneHover(true);
              setSelectedItem(7);
            }}
            onMouseLeave={() => {
              setOneHover(false);
              setSelectedItem(0);
            }}
            oneHover={oneHover}
            selectedItem={selectedItem === 7}
            onClick={() =>
              window.open('https://colorz-sollic.netlify.app/', '_blank')
            }
          >
            <Date
              color={colors.tan}
              fontSize={fontSize.small}
              fontFamily={fontFamily.tinos}
              bold={true}
              justify={false}
            >
              2019
            </Date>
            <Text
              color={colors.tan}
              fontSize={isSmallScreen ? fontSize.small : fontSize.title}
              fontFamily={fontFamily.tinos}
              bold={false}
              justify={false}
            >
              / Sollic
            </Text>
          </ProjectContainer>
          <ProjectContainer
            onMouseEnter={() => {
              setOneHover(true);
              setSelectedItem(8);
            }}
            onMouseLeave={() => {
              setOneHover(false);
              setSelectedItem(0);
            }}
            oneHover={oneHover}
            selectedItem={selectedItem === 8}
            onClick={() =>
              window.open(
                'https://awesome-feynman-6c0e31.netlify.app/',
                '_blank'
              )
            }
          >
            <Date
              color={colors.tan}
              fontSize={fontSize.small}
              fontFamily={fontFamily.tinos}
              bold={true}
              justify={false}
            >
              2018
            </Date>
            <Text
              color={colors.tan}
              fontSize={isSmallScreen ? fontSize.small : fontSize.title}
              fontFamily={fontFamily.tinos}
              bold={false}
              justify={false}
            >
              / Feed
            </Text>
          </ProjectContainer>
          <ProjectContainer
            onMouseEnter={() => {
              setOneHover(true);
              setSelectedItem(9);
            }}
            onMouseLeave={() => {
              setOneHover(false);
              setSelectedItem(0);
            }}
            oneHover={oneHover}
            selectedItem={selectedItem === 9}
            onClick={() =>
              window.open(
                'https://hetic-w1p2021-02-bowser.netlify.app/',
                '_blank'
              )
            }
          >
            <Date
              color={colors.tan}
              fontSize={fontSize.small}
              fontFamily={fontFamily.tinos}
              bold={true}
              justify={false}
            >
              2018
            </Date>
            <Text
              color={colors.tan}
              fontSize={isSmallScreen ? fontSize.small : fontSize.title}
              fontFamily={fontFamily.tinos}
              bold={false}
              justify={false}
            >
              / GeekMension
            </Text>
          </ProjectContainer>
        </Section>
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: 75vh; /* set the height to the desired value */
  overflow-y: scroll; /* show only vertical scrollbar */
  scrollbar-width: thin; /* set the width of the scrollbar */
  scrollbar-color: ${colors.tan} transparent; /* set the color of the scrollbar */
  margin-right: 10px; /* add a right margin */
  transform: perspective(1000px) rotateY(-30deg);

  /* Customize the scrollbar thumb and track */
  &::-webkit-scrollbar {
    width: 8px; /* set the width of the scrollbar */
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${colors.tan}; /* set the color of the thumb */
    border-radius: 10px; /* round the edges of the thumb */
  }

  &::-webkit-scrollbar-track {
    background-color: transparent; /* set the color of the track */
  }

  @media (min-height: 1000px) {
    height: 67.9vh;
  }

  @media (max-width: 1265px) {
    transform: perspective(0) rotateY(0);
  }
`;

const Section = styled.div`
  margin: 20px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 1265px) {
    margin: 0;
  }
`;

const ProjectContainer = styled.div<{
  selectedItem: boolean;
  oneHover: Boolean;
}>`
  display: flex;
  justify-content: end;
  align-items: center;

  @media (min-width: 776px) {
    cursor: pointer;
    filter: ${(props) =>
      !props.selectedItem && props.oneHover ? 'blur(5px)' : 'none'};
    transition: filter 0.3s ease;
  }

  @media (max-width: 1265px) {
    justify-content: start;
    padding-top: 6px;
  }
`;

const Date = styled(Text)`
  margin-right: 20px;
  font-weight: bold;

  @media (max-width: 1265px) {
    margin-right: 4px;
    font-weight: normal;
  }
`;

const Title = styled.div`
  display: flex;
  justify-content: end;
  @media (max-width: 1265px) {
    justify-content: start;
  }
`;

const CustomIcon = styled(Icon)`
  margin-right: 10px;
`;

export default Project;
